import { Button, Text } from '@chakra-ui/react';
import { useAppDispatch } from 'app/store';
import { openIntercomAction } from 'app/store/Mixpanel/slice';
import { useIntercom } from 'react-use-intercom';
import { WsImportResourceStatus } from 'types/websocket.types';

interface ErrorMessageProps {
  status: WsImportResourceStatus;
  error?: {
    errorCode?: string;
    message: string;
  };
}

export const ErrorMessage = ({ status, error }: ErrorMessageProps) => {
  const dispatch = useAppDispatch();
  const { show } = useIntercom();

  const errorMessageByStatus =
    status === 'FAILED_ONE'
      ? 'There was a problem importing one of the songs,'
      : 'Failed to import songs';

  const errorMessages = error
    ? error.message.split('\n')
    : [errorMessageByStatus];

  const errorMessageWithContact =
    status === 'FAILED_ONE'
      ? 'please try again. If issue persists '
      : 'Please check if your csv file is correct or ';

  return (
    <>
      <Text fontWeight="500" color="R.0" pb={2}>
        {error?.errorCode}
      </Text>
      {errorMessages.map((str) => (
        <Text color="R.0">{str}</Text>
      ))}
      <Text color="R.0">
        {errorMessageWithContact}
        <Button
          p={0}
          mb={0.5}
          variant="text"
          color="R.0"
          onClick={() => {
            show();
            dispatch(openIntercomAction());
          }}
        >
          contact us
        </Button>
        .
      </Text>
    </>
  );
};
